export const QUERY_KEYS = {
  loadStaticData: 'loadStaticData',
  businessData: 'businessData',
  locationList: 'locationList',
  loadCommodityList: 'loadCommodityList',
  lineItems: 'invoiceLineItems',
};
